module.exports = __webpack_public_path__ + "static/img/home-traceability.071de707.png";